import Videos from "../components/rows/Video/Videos";


const VideosPage = () =>
{
    return <Videos/>
}


export default VideosPage;